import { withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { BankAccountOrphanedModal } from '@features/openBanking/elements/BankConnectionStatusActions/elements/BankAccountOrphanedModal'
import { ConfirmDeleteConnectionModal } from '@features/openBanking/elements/BankIntegrationModals/elements/ConfirmDeleteConnectionModal'
import { ConnectionRenewedModal } from '@features/openBanking/elements/BankIntegrationModals/elements/SuccessfulConnectionModal'
import { redirectToAiia } from '@features/openBanking/utils/redirectToAiia'

import { ModalId } from '../../../../../../../../enums/modalId'

const BankConnectionDeleteConfirmationModal = withModalConditionalRender(ConfirmDeleteConnectionModal)
const BankConnectionRenewedModal = withModalConditionalRender(ConnectionRenewedModal)
const BankAccountOrphanedModalComponent = withModalConditionalRender(BankAccountOrphanedModal)

export const BankAccountModals = (): ReactElement => (
  <>
    <BankConnectionRenewedModal id={ModalId.BankConnectionSuccessModal} />
    <BankConnectionDeleteConfirmationModal
      id={ModalId.BankConnectionRemoveConfirmationModal}
      removeConnection={redirectToAiia}
    />
    <BankAccountOrphanedModalComponent id={ModalId.BankAccountOrphanedModal} />
  </>
)
